import { linkDefaults } from "@/modules/billing/paymentMethodDefaults.tsx";
import type { LinkMethod } from "@/modules/billing/paymentMethods.ts";
import RazorpayPaymentForm, {
    type RazorpayLinkProcessorConfig,
} from "@/modules/billing/razorpay/RazorpayPaymentForm.tsx";

export function makeRazorpayLink(config: RazorpayLinkProcessorConfig) {
    return config.methods.map((method): LinkMethod => {
        const base = linkDefaults(config, method);
        return {
            ...base,
            PaymentForm: (props) => <RazorpayPaymentForm {...props} method={method} config={config} />,
        };
    });
}
